import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NebulaIconSizeDirective } from './nebula-icon-size.directive';

@NgModule({
  exports: [
    MatIconModule,
    NebulaIconSizeDirective
  ],
  declarations: [
    NebulaIconSizeDirective
  ]
})
export class NebulaIconsModule { }
